import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { LoginMethods, type LoginMethodsNotice } from '../../../components/login-methods.tsx'
import { ProfileHeader } from '../../../components/profile-header.tsx'
import { meQuery } from '../../../lib/session.ts'

export const Route = createFileRoute('/_authed/_shell/profile/login-methods')({
  validateSearch: (s: Record<string, unknown>): LoginMethodsNotice => ({
    linked: typeof s.linked === 'string' ? s.linked : undefined,
    error: typeof s.error === 'string' ? s.error : undefined,
    provider: typeof s.provider === 'string' ? s.provider : undefined,
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(meQuery),
  component: LoginMethodsScreen,
})

/** "Профиль · способы входа": a sub-screen on phones, the profile page with methods elsewhere. */
function LoginMethodsScreen() {
  const notice = Route.useSearch()
  const navigate = useNavigate()
  const { data: me } = useSuspenseQuery(meQuery)
  if (!me) return null

  return (
    <div className="mx-auto flex w-full max-w-[760px] flex-col gap-7 px-5 pt-[max(16px,var(--tg-viewport-content-safe-area-inset-top,0px))] pb-10 md:px-10 md:pt-8 xl:mx-0 xl:px-14 xl:pt-10">
      <header className="flex flex-col gap-3 md:hidden">
        <div className="flex h-11 items-center justify-between">
          <Link
            to="/profile"
            aria-label="Назад"
            className="flex size-11 items-center justify-center rounded-full bg-card"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
          <span className="font-medium text-ink-2 text-sm">Профиль</span>
          <span className="size-11" />
        </div>
        <h1 className="font-bold font-display text-[28px] tracking-[-1px]">Способы входа</h1>
        <p className="text-ink-2 text-sm leading-[1.45]">
          Входите любым способом — аккаунт один. Последний способ отвязать нельзя.
        </p>
      </header>
      <div className="hidden md:block">
        <ProfileHeader me={me} />
      </div>
      <LoginMethods
        me={me}
        notice={notice}
        onNoticeDone={(next) => void navigate({ to: '.', search: next ?? {}, replace: true })}
      />
    </div>
  )
}
